import {
  IInstructorApprover,
  IError,
  IQueryHookOptions,
} from '@comptia-sso/core';
import { useQuery } from 'react-query';

// Services.
import { getInstructorApprover } from 'services';

type UseInstructorApprover = [IInstructorApprover, IQueryHookOptions];

export const useInstructorApprover = (id = ''): UseInstructorApprover => {
  const {
    data = {} as IInstructorApprover,
    error,
    isError,
    isLoading,
  } = useQuery<IInstructorApprover, IError>(
    ['instructor-approvers', id],
    () => getInstructorApprover(id),
    {
      enabled: !!id,
    },
  );

  return [data, { error, isError, isLoading }];
};
